import Header from '../../../../Components/Header'
import Updatezone from './Updatezone'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
function UpdateZoneMaster() {
    const location = useLocation();
    const warehouseData = location.state;
    return (
           <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Zone - Edit</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <Updatezone warehouseData={warehouseData} />
            </div>
        </div>

    )
}

export default UpdateZoneMaster
